import * as appEntities from 'app/store/index';
import { useSelector } from 'react-redux';

export function useAuthUser() {
  const authToken = useSelector((state) => appEntities.auth.selectors.getAuthToken(state));
  const authUser = useSelector((state) => appEntities.auth.selectors.getUser(state));

  return {
    authToken,
    authUser,
  };
}
